/**
 * 协作者触发了会员相关的逻辑时候的参数
 */

/**
 * status 从未设置：0 匿名状态 1: 开启 2: 关闭
 */
export var PersonalizeAnonymousStatus = /*#__PURE__*/function (PersonalizeAnonymousStatus) {
  PersonalizeAnonymousStatus[PersonalizeAnonymousStatus["NONE"] = 0] = "NONE";
  PersonalizeAnonymousStatus[PersonalizeAnonymousStatus["OPEN"] = 1] = "OPEN";
  PersonalizeAnonymousStatus[PersonalizeAnonymousStatus["CLOSED"] = 2] = "CLOSED";
  return PersonalizeAnonymousStatus;
}({});
/**
 * 协作者列表变更事件参数
 */

/**
 * 后端需要的校验标识
 * 通过这些标记，后端有不同的校验逻辑，
 * 防止该接口成为一个超级接口，可以遍历出所有用户信息
 */

/**
 * getusermarkname 接口方法数据缓存信息类型, 用于缓存
 * @description 包括未命中缓存的 id 以及命中缓存的数据
 */

/**
 * 协作者触发了会员相关的逻辑时候的参数
 */
//# sourceMappingURL=entity.js.map